export const EVENT_NAMES = Object.freeze({
  ARTIFACT_OPENED: 'artifact_opened',
  ARTIFACT_DOWNLOADED: 'artifact_downloaded',
  STUDENT_MESSAGE_SENT: 'student_message_sent',
  IA_ACTIVITY_VIEWED: 'ia_activity_viewed',
  IA_PROGRESS_OPENED: 'ia_progress_opened',
  IA_SUBJECT_DETAIL_OPENED: 'ia_subject_detail_opened',
  TUTOR_ERROR_REPORTED: 'tutor_error_reported',
  TUTOR_RESPONSE_FEEDBACK: 'tutor_response_feedback',
  ACTIVITY_SESSION_DISCARDED: 'activity_session_discarded',
  ACTIVITY_SESSION_SAVED_FOR_LATER: 'activity_session_saved_for_later',
  USER_FEEDBACK_SUBMITTED: 'user_feedback_submitted',
  IA_TEACHER_TOOLS_OPENED: 'ia_teacher_tools_opened',
  IA_TEACHER_TOOL_CLICKED: 'ia_teacher_tool_clicked',
  TOOL_OUTPUT_GENERATED: 'tool_output_generated',
  TOOL_OUTPUT_GENERATION_FAILED: 'tool_output_generation_failed',
  NEW_CONVERSATION_CLICKED: 'new_conversation_clicked',
  TUTOR_MESSAGE_FAILED: 'tutor_message_failed',
  FORMULA_ADDED: 'formula_added',
  TUTOR_MESSAGE_PLAY_BUTTON_CLICKED: 'tutor_message_play_button_clicked',
  TUTOR_MESSAGE_REPRODUCED: 'tutor_message_reproduced',
  SOURCE_CLICKED: 'source_clicked',
  CONVERSATION_RESUMED: 'conversation_resumed',
});
